jQuery(function($)
{
    let
        api = orion.api.b2bApiKey,
        $showApiKeyButton = $('.js-show-api-key-action');

    function showApiKey(e)
    {
        e.preventDefault();

        let elementId = $(this).attr('id');
        // element id ends with <publicAccessId>-<timestamp>
        // both parameters needed for api call:
        let elementIdRegEx = /(\w+)-(\d+)$/;
        let match = elementIdRegEx.exec(elementId);
        let [, publicAccessId] = match;
        let [,, timestamp] = match;

        var $feedbackContainer = $('<span></span>');
        $feedbackContainer.addClass('feedback-container');

        $(this).addClass('loading');

        $(this).prepend($feedbackContainer);

        let $that = $(this);

        api.fetchApiKey(publicAccessId, timestamp)
            .done(function(data)
            {
                // replace div/span contents of the cell with API key
                $that.parent().find('.js-api-key-element').html(data);
                $that.parent().find('.js-api-key-container').show();
                $that.removeClass('loading');
                $that.find('.feedback-container').remove();
                $that.hide();
            })
            .fail(function()
            {
                // default contents is the error message. hide copy-to-clipboard
                // if no key is shown:
                $that.parent().find('.js-copy-api-key-to-clipboard-trigger').hide();
                $that.parent().find('.js-api-key-container').show();
                $that.removeClass('loading');
                $that.find('.feedback-container').remove();
                $that.hide();
            });
    }

    $showApiKeyButton.on('click', showApiKey);
});
